import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { IntroductionLayout } from "netcompany-mdx-slide";
import { Head } from "mdx-deck";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Head mdxType="Head">
  <title>OOP in Practice</title>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
  <link href="https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c:wght@800;900&family=Nunito&family=Varela+Round&display=swap" rel="stylesheet" />
    </Head>
    <p>{`hello`}</p>
    <hr></hr>
    <IntroductionLayout title={"OOP\nin Practice"} department={"CoEs"} mdxType="IntroductionLayout" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      